import { memo, forwardRef, ReactNode } from 'react';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/material';

// ----------------------------------------------------------------------

interface ScrollbarProps {
    children?: ReactNode;
    sx?: SxProps;
}

const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>(({ children, sx, ...other }, ref) => {
    const userAgent = typeof navigator === 'undefined' ? 'SSR' : navigator.userAgent;

    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

    if (mobile) {
        return (
            <Box ref={ref} sx={{ overflow: 'auto', ...sx }} {...other}>
                {children}
            </Box>
        );
    }

    return <div ref={ref} {...other}>{children}</div>;
});

Scrollbar.displayName = 'Scrollbar';

export default memo(Scrollbar);